import React from 'react';
import { useSelector } from 'react-redux';
import { Map } from 'mapbox-gl';

import { CollapsibleContainer, Badge } from 'modules/ui/components';
import { isOnlineSelector, isUiVisibleSelector } from 'modules/metadata';
import { useDisplayCurrentLocation } from 'modules/location';
import { useGetUser, useGetUserPlanInfo } from 'modules/user';

import Header from './Header';
import { BoatSideMenuSection } from '../BoatSideMenuSection';
import { ConnectionSideMenuSection } from '../ConnectionSideMenuSection';
import { FleetSideMenuSection } from '../FleetSideMenuSection';
import { SubscriptionSideMenuSection } from '../SubscriptionSideMenuSection';

import { BadgeContainer, OfflineText } from './styledComponents';
import { LocationHeader } from './LocationHeader';

type Props = {
  onModeChange: (value: boolean) => void;
  onVisibilityChange: (value: string | null) => void;
  id: string;
  isOpened: boolean;
  map: Map;
};

const HomeSideMenu: React.FC<Props> = ({
  // onModeChange,
  isOpened,
  onVisibilityChange,
  id,
  map,
}) => {
  const isOnline = useSelector(isOnlineSelector);
  const isUiVisible = useSelector(isUiVisibleSelector);
  const pricingEnabled = process.env.REACT_APP_STRIPE_ENABLED === 'true';
  useGetUser();
  useDisplayCurrentLocation(map);
  const { name: planName } = useGetUserPlanInfo();

  const showFleetData = false;

  return (
    <>
      <CollapsibleContainer
        isVisible={isUiVisible}
        opacity={0.8}
        isOpened={isOpened}
        onVisibilityChange={onVisibilityChange}
        id={id}
        title="General"
        RightTitleComponent={
          isOnline ? (
            pricingEnabled && (
              <BadgeContainer>
                <Badge label={planName} />
              </BadgeContainer>
            )
          ) : (
            <OfflineText>Offline mode</OfflineText>
          )
        }
        // TODO Fleet data
        HeaderComponent={
          <>
            {showFleetData && <Header map={map} />}
            <LocationHeader />
          </>
        }
      >
        {showFleetData && <FleetSideMenuSection />}
        <BoatSideMenuSection addPadding={showFleetData} />
        {pricingEnabled && <SubscriptionSideMenuSection />}
        <ConnectionSideMenuSection />
      </CollapsibleContainer>
    </>
  );
};

export default React.memo(HomeSideMenu);
